<template>
  <div :class="clase ? 'position' : ''">
    <div class="spinner"></div>
  </div>
</template>

<script>
export default {
  props:{
    clase:{
      type:Boolean,
      default:true
    }
  }
};
</script>

<style>
.position {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 45vh;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  align-content: center;
  /* background-color: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  z-index: 101; */
}
.spinner {
  position: relative;
  border: 6px solid rgba(0, 0, 00, 0.1);
  width: 80px;
  height: 80px;
  border-radius: 50%;
  border-left-color: #09f;
  animation: spin 1s ease infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
